import { createSelector } from "reselect";
import get from "src/lib/get";
import { getUser } from ".";

export const returnedOrdersIsPending = createSelector(getUser, (data) => {
  return get(data, "returnedOrders.isPending", false);
});
